import React, { createContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../../constants/routesContent.json";
import Details from "../../constants/dummyData.json";
import {
  getEmployeeList,
  getEmployeeDetail,
  getSearchedEmployeeList,
  employeeListExcel,
  deleteEmployeeData,
} from "../../api/Api";
import { useState } from "react";
import { permittedIDs } from "../../components/TopBarComponent/Topbar";

export const EmployeeMasterContext = createContext({});
export const EmployeeMasterContextProvider = ({ children }) => {
  const downloadEmployeeListExcelPermission =
    permittedIDs && permittedIDs.includes(5);
  const [employeeList, setEmployeeList] = useState([]);
  const [employeeId, setEmployeeId] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setcurrentPage] = useState(1);
  const [searchBox, setSearchBox] = useState("");
  const [employeeExcel, setEmployeeExcel] = useState();
  const [statusCode, setStatusCode] = useState(0);
  const [spinnerStatus ,setSpinnerStatus] = useState(false)
  const navigate = useNavigate();
  const content = Details.employeeMaster;
  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteConstants.LOGIN);
    //navigate(RouteConstants.EMPLOYEE_MASTER);
  };
  const getEmployeeData = (employeeCode) => {
    const visitorDetail = employeeList?.filter((item) => {
      if (item?.EmployeeCode === employeeCode) {
        navigate(RouteConstants.EMPLOYEE_DETAILS, { state: item?.EmployeeId });
      }
    });
    return visitorDetail;
  };

  const handleSearchPress = (target) => {
    ["'"].includes(target.key) && target.preventDefault();
    if (target.key == "Enter") {
      setcurrentPage(1);
      searchedEmployeeList(1, searchBox);
    }
  };

  const callGetEmployeeDetail = async (employeeId) => {
    try {
      const getData = await getEmployeeDetail(employeeId);
      if (getData?.data?.status === 200) {
        const employeeInfo = getData.data?.data?.employee;
        navigate(RouteConstants.EMPLOYEE_REGISTRATION, {
          state: { isEdit: true, employeeData: employeeInfo },
        });
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };

  const editEmployeeDetail = (EmployeeId) => {
    const visitorDetail = employeeList?.filter((item) => {
      if (item?.EmployeeId === EmployeeId) {
        callGetEmployeeDetail(item?.EmployeeId);
      }
    });
    return visitorDetail;
  };

  const deleteEmpDetail = async (employeeId) => {
    try {
      const getData = await deleteEmployeeData(employeeId);
      if (getData?.data?.status === 200) {
        // const employeeInfo = getData.data?.data?.employee;
        // navigate(RouteConstants.EMPLOYEE_REGISTRATION);
        setShowAlert(true);
        setAlertMessage(getData?.data?.message);
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };

  const callGetEmployeeList = async (pageNumber) => {
    const data = {
      page: pageNumber,
    };
    try {
      const getData = await getEmployeeList(data);
      setStatusCode(getData?.data?.status);
      if (getData?.data?.status === 200) {
        setEmployeeList(getData.data?.data?.employees);
        setPageCount(getData.data?.data?.numPages);
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (error.response.data.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
        //setEmployeeList([]);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };

  const callGetEmployeeListExcel = async () => {
    try {
      const getExcel = await employeeListExcel();
      if (getExcel.status === 200) {
        setEmployeeExcel(getExcel.data.data.filename);
      }
      console.log(getExcel);
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  //////////////////////////////////////

  const searchedEmployeeList = async (pageNumber, searchText) => {
    const data = {
      page: pageNumber,
      searchText: searchText,
    };
    setSpinnerStatus(true)
    try {
      const getData = await getSearchedEmployeeList(data);
      if (getData?.data?.status === 200) {
        setSpinnerStatus(false)
        setEmployeeList(getData.data?.data?.employees);
        setPageCount(getData.data?.data?.numPages);
      }
    } catch (error) {
      setSpinnerStatus(false)
      setStatusCode(error?.response?.data?.status);
      if (error.response.data.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error.response.data.status === 400) {
        const errorMessage = error.response.data.message;
        setEmployeeList([]);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };

  /////////////////////////////////////

  const goBack = () => {
    navigate(-1);
  };

  const addEmployee = () => {
    navigate(RouteConstants.EMPLOYEE_REGISTRATION);
  };

  useEffect(() => {
    callGetEmployeeList();
    callGetEmployeeListExcel();
  }, []);

  // useEffect(() => {
  //   console.log("The search value changed");
  // }, [searchBox]);

  const onPageChange = (e) => {
    setcurrentPage(e);
    searchedEmployeeList(e, searchBox);
  };

  const providerValue = {
    addEmployee,
    goBack,
    employeeList,
    getEmployeeData,
    editEmployeeDetail,
    showAlert,
    setShowAlert,
    callGetEmployeeListExcel,
    alertMessage,
    callGetEmployeeList,
    logout,
    statusCode,
    pageCount,
    currentPage,
    setcurrentPage,
    onPageChange,
    handleSearchPress,
    searchBox,
    setSearchBox,
    employeeExcel,
    deleteEmpDetail,
    downloadEmployeeListExcelPermission,
    spinnerStatus ,setSpinnerStatus
  };
  return (
    <EmployeeMasterContext.Provider value={providerValue}>
      {children}
    </EmployeeMasterContext.Provider>
  );
};
